module.exports = __webpack_public_path__ + "img/09_mke_20250515_csorgedezesesaradas_67.31b35ad3.jpg";